import {SupportedLanguage} from '../types';

interface FormatOptions {
	date: string;
	lang: SupportedLanguage;
	dateOptions?: Intl.DateTimeFormatOptions;
}

export function formatDate({
	date,
	lang,
	dateOptions = {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	},
}: FormatOptions): string {
	const dateLocales =
		lang === 'ar'
			? ['ar-OM-u-nu-arab-ca-islamic-civil', 'ar-u-nu-arab']
			: 'en-GB';

	return new Intl.DateTimeFormat(dateLocales, dateOptions).format(
		new Date(date),
	);
}
